import { ContactButton } from "@/components/blocks/ContactButton";
import { Button } from "@/components/ui/button";
import type { ContactNeed } from "@/lib/contact";

/** Primary contact action plus the anchor to the page's process. */
export function ServiceHeroActions({
	need,
	placement,
	primary,
	secondary,
	processId,
}: {
	need: ContactNeed;
	placement: string;
	primary: string;
	secondary: string;
	processId: string;
}) {
	return (
		<>
			<ContactButton need={need} placement={placement}>
				{primary}
			</ContactButton>
			<Button
				size="lg"
				variant="ghost"
				className="h-auto min-h-11 rounded-lg px-6 font-mono text-[13px] whitespace-normal"
				asChild
			>
				<a href={`#${processId}`}>{secondary}</a>
			</Button>
		</>
	);
}
